import React from 'react';

import HeaderMastheadBasic from './HeaderMastheadBasic/HeaderMastheadBasic';
import HeaderMastheadFullImage from './HeaderMastheadFullImage/HeaderMastheadFullImage';
import HeaderMastheadHalfImage from './HeaderMastheadHalfImage/HeaderMastheadHalfImage';
import HeaderMastheadTwoColumns from './HeaderMastheadTwoColumns/HeaderMastheadTwoColumns';

const HeaderMasthead = ({ headerData }) => {
  const { typeHandle } = headerData;

  if (!typeHandle) {
    return null;
  }

  switch (typeHandle) {
    case 'halfImage':
      return <HeaderMastheadHalfImage headerData={headerData} />;
    case 'fullImage':
      return <HeaderMastheadFullImage headerData={headerData} />;
    case 'twoColumn':
      return <HeaderMastheadTwoColumns headerData={headerData} />;
    case 'basic':
      return <HeaderMastheadBasic headerData={headerData} />;
    default:
      return null;
  }
};

export default HeaderMasthead;
